import { createBrowserRouter, Navigate, useParams } from 'react-router-dom'
import { Home } from './routes/Home'
import { Features } from './routes/Features'
import { Pricing } from './routes/Pricing'
import { About } from './routes/About'
import { Demo } from './routes/Demo'
import { Login } from './routes/Login'
import { Register } from './routes/Register'
import { Navbar } from './components/Navbar'
import { Footer } from './components/Footer'
import { RoleSelector } from './components/RoleSelector'

// Component to redirect /tenants/{slug} to /t/{slug}/
function TenantRedirect() {
  const { slug } = useParams<{ slug: string }>()
  const restPath = window.location.pathname.replace(`/tenants/${slug}`, '') || '/'
  const redirectPath = `/t/${slug}${restPath}`
  return <Navigate to={redirectPath} replace />
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <Home />
        </main>
        <Footer />
        <RoleSelector />
      </div>
    ),
  },
  {
    path: '/features',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <Features />
        </main>
        <Footer />
      </div>
    ),
  },
  {
    path: '/pricing',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <Pricing />
        </main>
        <Footer />
      </div>
    ),
  },
  {
    path: '/about',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <About />
        </main>
        <Footer />
      </div>
    ),
  },
  {
    path: '/demo',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <Demo />
        </main>
        <Footer />
      </div>
    ),
  },
  {
    path: '/login',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <Login />
        </main>
        <Footer />
      </div>
    ),
  },
  {
    path: '/register',
    element: (
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-grow">
          <Register />
        </main>
        <Footer />
      </div>
    ),
  },
  // Redirect old /tenants/{slug} format to new /t/{slug}/ format
  {
    path: '/tenants/:slug',
    element: <TenantRedirect />,
  },
  {
    path: '/tenants/:slug/*',
    element: <TenantRedirect />,
  },
], {
  future: {
    v7_startTransition: true,
  }
})

